import { fetchDataEngine } from "../../data/Axios/DynamicService";

export const handleGlobalChange = async (
  inputobjectname,
  inputsubobjectname,
  inputfields,
  returnfields,
  base_url,
) => {
  try {
    const data = await fetchDataEngine(
      inputobjectname,
      inputsubobjectname,
      inputfields,
      returnfields,
      base_url,
    );
    return data;
  } catch (error) {
    console.error("Error fetching global change data:", error);
    return [];
  }
};
